// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { getAuth } from "api/auth";
import { jwtDecode } from "jwt-decode";
import { roleExpEnum, areaPP } from "config/enum";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";

import breakpoints from "assets/theme/base/breakpoints";
import Card from "@mui/material/Card";
/* import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon"; */
import MDAvatar from "components/MDAvatar";
import { setCurrentDevices } from "../../../redux/reducers/devicesReducer";
import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";
import { useDispatch } from "react-redux";

function Accueil() {
  const { user, setUser } = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  /* const [tabValue, setTabValue] = useState(0); */
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
    The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  /* const handleSetTabValue = (event, newValue) => setTabValue(newValue); */

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    dispatch(setCurrentDevices([]));
    dispatch(setCurrentOrder(null));
  }, [dispatch]);

  useEffect(() => {
    let isMounted = true;

    const existingSessionToken = localStorage.getItem("sessionToken");
    if (existingSessionToken) {
      try {
        const decoded = jwtDecode(existingSessionToken);
        if (!Array.isArray(decoded.user_areas)) {
          decoded.user_areas = decoded.user_area ? [decoded.user_area] : [];
        }
        if (decoded.exp > Date.now() / 1000) {
          setUser(decoded);
          return;
        }
      } catch (error) {
        console.error("Error with existing session token:", error);
      }
    }

    const token = new URLSearchParams(location.search).get("token");
    if (token) {
      getAuth(token)
        .then((response) => {
          if (isMounted && response && response.status === 200) {
            setSnackbarOpen(true);
            setSnackbarMessage("Vous avez été connecté avec succès !");
            const newSessionToken = localStorage.getItem("sessionToken");
            if (newSessionToken) {
              const decoded = jwtDecode(newSessionToken);
              if (!Array.isArray(decoded.user_areas)) {
                decoded.user_areas = decoded.user_area ? [decoded.user_area] : [];
              }
              setUser(decoded);
            }
          } else {
            navigate("/connexion");
          }
        })
        .catch((error) => {
          if (isMounted) {
            console.error("Authentication error:", error);
            navigate("/connexion");
          }
        });
    } else {
      navigate("/connexion");
    }

    return () => {
      isMounted = false;
    };
  }, [location, navigate, setUser]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={10000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          variant="filled"
          severity="success"
          sx={{ width: "100%", color: "white !important" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <MDBox mb={3} />
      <MDBox position="relative" mb={5}>
        <Card
          sx={{
            position: "relative",
            py: 2,
            px: 2,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item>
              <MDAvatar
                src={areaPP[user && user.user_areas && user.user_areas[0]]}
                alt="profile-image"
                size="xl"
                shadow="sm"
              />
            </Grid>
            <Grid item>
              <MDBox mt={0.5} children lineHeight={1}>
                <MDTypography variant="h5" fontWeight="medium">
                  {user ? `${user.first_name} ${user.last_name}` : "Chargement..."}
                </MDTypography>
                <MDTypography variant="button" color="text" fontWeight="regular">
                  {user ? user.role : "Chargement..."}
                </MDTypography>
              </MDBox>
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
              <AppBar position="static">
                <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
                  <Tab
                    label="App"
                    icon={
                      <Icon fontSize="small" sx={{ mt: -0.25 }}>
                        home
                      </Icon>
                    }
                  />
                  <Tab
                    label="Message"
                    icon={
                      <Icon fontSize="small" sx={{ mt: -0.25 }}>
                        email
                      </Icon>
                    }
                  />
                  <Tab
                    label="Settings"
                    icon={
                      <Icon fontSize="small" sx={{ mt: -0.25 }}>
                        settings
                      </Icon>
                    }
                  />
                </Tabs>
              </AppBar>
            </Grid> */}
          </Grid>
          <MDBox mt={5} mb={3}>
            <Grid container spacing={1}>
              <Grid item md={12} xl={4.5} sx={{ display: "flex" }}>
                <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                <ProfileInfoCard
                  title="Informations du compte"
                  description={user ? roleExpEnum[user && user.role] : "Chargement..."}
                  role={user ? user.role : "Chargement..."}
                  info={{
                    Prénom: user && user.first_name ? user.first_name : "Non rensigné",
                    Nom: user && user.last_name ? user.last_name : "Non rensigné",
                    Rôle: user && user.role,
                    Téléphone: user && user.phone_number ? user.phone_number : "Non rensigné",
                    Email: user && user.email,
                    Zone: user && user.user_areas && user.user_areas.length > 0 ? user.user_areas.join(", ") : "Non renseignée",
                  }}
                  /* action={{ route: "", tooltip: "Edit Profile" }} */
                  shadow={false}
                />
                <Divider orientation="vertical" sx={{ mx: 0 }} />
              </Grid>
              <Grid item md={12} xl={7.5}>
                <ProfilesList title="Vos impératifs" shadow={false} />
              </Grid>
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default Accueil;
